<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="scope !== null">

    <div class="p-grid p-mb-4">
      <div class="p-col-6">
        <h2>{{ t('common.labels.businessunits') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
        <button [withRight]="editRight" *ngIf="loading !== true" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div *ngIf="hasEmptyEntries()" role="alert" class="p-messages p-component p-mb-4">
      <div role="alert" class="p-message p-message-warn">
        <div class="p-message-wrapper">
          <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
          <span class="p-message-detail">{{ t('common.messages.empty_dimension_no_access') }}</span>
        </div>
      </div>
    </div>

    <app-loader [loading]="loading"></app-loader>

    <ng-container *ngIf="loading !== true">

      <p-table
        styleClass="p-datatable-sm"
        [value]="groups"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        dataKey="id"
        stateKey="data-scope-businessunits-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >

        <ng-template pTemplate="colgroup">
          <colgroup>
              <col style="width: 40px;">
              <col>
              <col style="width:90px">
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
              <th></th>
              <th>{{ t('common.labels.name') }}</th>
              <th>{{ t('common.labels.enabled') }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-group let-expanded="expanded">
          <tr tabindex="0" [ngClass]="{'expanded': expanded}">
            <td>
              <button type="button" pButton pRipple [pRowToggler]="group" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td>{{ group.name }}</td>
            <td></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-group>
          <tr *ngFor="let child of group.businessunits" class="child">
            <td></td>
            <td style="padding-left: 50px;" [ngClass]="{inactive: child.control_enabled.value !== true}">{{ child.name }}</td>
            <td>
              <app-form-control [cid]="'bu_' + child.id + '_enabled'" [control]="child.control_enabled" [type]="'checkbox'" [edit]="inEdit" [basevalue]="child.control_enabled.value" [noMargin]="true" [showLabel]="false"></app-form-control>
            </td>
          </tr>
          <tr class="child-border">
            <td colspan="3"></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="3">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>

      <ng-container *ngIf="orphans.length > 0">
        <div role="alert" class="p-messages p-component p-mt-4 p-mb-4">
          <div role="alert" class="p-message p-message-warn">
            <div class="p-message-wrapper">
              <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
              <span class="p-message-detail">{{ t('common.messages.orphan_entry_still_effective') }}</span>
            </div>
          </div>
        </div>
        <p-table
          styleClass="p-datatable-sm"
          [value]="orphans"
          [paginator]="false"
        >
          <ng-template pTemplate="colgroup">
            <colgroup>
                <col>
                <col style="width:90px">
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
                <th>{{ t('common.labels.name') }}</th>
                <th>{{ t('common.labels.enabled') }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-orphan>
              <tr>
                <td>{{ orphan.name }}</td>
                <td>
                  <input type="checkbox" checked disabled>
                </td>
              </tr>
          </ng-template>
        </p-table>
      </ng-container>

    </ng-container>

  </form>
</ng-container>
